export function parseGmapAddress (ar) {
  const ret = {}
  ar && ar.forEach(a => {
    if (a.types.includes('street_number')) {
      ret.streetNumber = a.short_name
    }
    if (a.types.includes('route')) {
      ret.streetName = a.short_name
    }
    if (a.types.includes('locality')) {
      ret.city = a.long_name
    }
    if (a.types.includes('administrative_area_level_1')) {
      ret.state = a.long_name
    }
    if (a.types.includes('country')) {
      ret.country = a.short_name
    }
    if (a.types.includes('postal_code')) {
      ret.zipCode = a.short_name
    }
  })

  ret.address = [
    [ret.streetNumber, ret.streetName].filter(Boolean).join(' '),
    ret.city, ret.state, ret.zipCode,
  ].filter(Boolean).join(', ')

  return ret
}
